import React from "react";
import { generateLetter } from "../api";

export default function AIStrategyModal({
  account,
  onClose,
  onGenerated,
}) {
  if (!account) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,.65)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "30px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "760px",
          maxHeight: "90vh",
          overflowY: "auto",
          background: "#ffffff",
          borderRadius: "22px",
          padding: "28px",
          boxShadow: "0 30px 80px rgba(0,0,0,.30)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "28px",
                fontWeight: "800",
                color: "#D4AF37",
              }}
            >
              🧠 Integrity AI Strategy
            </div>

            <div
              style={{
                color: "#64748b",
                marginTop: "6px",
              }}
            >
              {account.creditor}
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "#e2e8f0",
              padding: "10px 18px",
              borderRadius: "12px",
              cursor: "pointer",
              fontWeight: "700",
            }}
          >
            Close
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
            gap: "16px",
            marginBottom: "28px",
          }}
        >
          <Info
            title="Risk Score"
            value={`${account.risk_score || 0}/100`}
          />

          <Info
            title="Priority"
            value={account.priority || "N/A"}
          />

          <Info
            title="Deletion Probability"
            value={`${account.deletion_probability || 0}%`}
          />

          <Info
            title="Recommended Letter"
            value={account.recommended_letter || "General Dispute"}
          />
        </div>

        <Section title="Issues Detected">
          {account.issues?.length ? (
            account.issues.map((issue, i) => (
              <Bullet key={i} text={issue} />
            ))
          ) : (
            <Bullet text="General Accuracy Review" />
          )}
        </Section>

        <Section title="Evidence Checklist">
          <Bullet text="Current Credit Report" />
          <Bullet text="Previous Credit Report" />
          <Bullet text="Bankruptcy Discharge (if applicable)" />
          <Bullet text="Previous Bureau Responses" />
          <Bullet text="Payment History" />
        </Section>

        <Section title="Applicable Laws">
          <Bullet text="FCRA §611 - Accuracy Investigation" />
          <Bullet text="FCRA §623 - Furnisher Responsibilities" />
          <Bullet text="FCRA §607(b) - Maximum Possible Accuracy" />
          <Bullet text="Metro 2 Compliance Review" />
        </Section>

        <Section title="AI Recommendation">
          <div
            style={{
              lineHeight: 1.7,
              color: "#334155",
            }}
          >
            {account.suggested_action}
          </div>
        </Section>

        <div
          style={{
            display: "flex",
            gap: "12px",
            marginTop: "30px",
            flexWrap: "wrap",
          }}
        >
          <button
            style={buttonStyle}
            onClick={async () => {
              try {
                const payload = {
                  client_id: account.client_id,
                  template: account.recommended_letter || "General Dispute",
                  letter_type: account.recommended_letter || "General Dispute",
                  bureau: account.bureau || "Experian",
                  creditor: account.creditor || "Unknown Account",
                  account: account.account_number || "N/A",
                  details: [
                    ...(Array.isArray(account.issues)
                      ? account.issues.map((issue) => `Disputed issue: ${issue}`)
                      : []),

                    account.review_reason
                      ? `Reason for review: ${account.review_reason}`
                      : "",

                    account.next_action
                      ? `Requested review: ${account.next_action}`
                      : "",

                    !account.issues?.length &&
                    !account.review_reason &&
                    !account.next_action
                      ? (
                          account.suggested_action ||
                          "Please investigate this account for accuracy, completeness, and compliance."
                        )
                      : "",
                 ]
                    .filter(Boolean)
                    .join("\n"),
                };

                await generateLetter(payload);

                alert("Letter generated and saved successfully.");
              } catch (err) {
                alert(
                  "Failed to generate letter: " +
                    (err?.message || "Unknown error")
                );
              }
            }}
          >
            📄 Generate Letter
          </button>

         <button
           style={{
             ...buttonStyle,
             background: "#16a34a",
           }}
           onClick={async () => {
             try {
               const payload = {
                 client_id: account.client_id,
                 template: account.recommended_letter || "General Dispute",
                 letter_type: account.recommended_letter || "General Dispute",
                 bureau: account.bureau || "Experian",
                 creditor: account.creditor || "Unknown Account",
                 account: account.account_number || "N/A",
                 details: [
                   ...(Array.isArray(account.issues)
                     ? account.issues.map((issue) => `Disputed issue: ${issue}`)
                     : []),

                 account.review_reason
                   ? `Reason for review: ${account.review_reason}`
                   : "",

                 account.next_action
                   ? `Requested review: ${account.next_action}`
                   : "",

                 !account.issues?.length &&
                 !account.review_reason &&
                 !account.next_action
                   ? (
                       account.suggested_action ||
                       "Please investigate this account for accuracy, completeness, and compliance."
                     )
                   : "",
               ]
                 .filter(Boolean)
                 .join("\n"),
               };

               await generateLetter(payload);

               if (onGenerated) {
                 await onGenerated();
               }

               alert(
                 "🚀 Integrity AI AutoPilot generated the " +
                   (account.recommended_letter || "recommended dispute letter") +
                   " for " +
                   (account.creditor || "this account") +
                   "."
               );

               onClose();
             } catch (err) {
               alert(
                 "❌ AutoPilot failed: " +
                   (err?.message || "Unknown error")
              );
             }
           }}
         >
           🚀 Start AI AutoPilot
         </button>

         <button
           style={{
             ...buttonStyle,
             background: "#0f172a",
           }}
           onClick={onClose}
         >
           Close
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <div
        style={{
          fontWeight: "800",
          fontSize: "18px",
          color: "#0f172a",
          marginBottom: "10px",
        }}
      >
        {title}
      </div>

      {children}
    </div>
  );
}

function Bullet({ text }) {
  return (
    <div
      style={{
        marginBottom: "8px",
        color: "#475569",
      }}
    >
      ✓ {text}
    </div>
  );
}

function Info({ title, value }) {
  return (
    <div
      style={{
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        borderRadius: "16px",
        padding: "18px",
      }}
    >
      <div
        style={{
          color: "#64748b",
          fontSize: "14px",
        }}
      >
        {title}
      </div>

      <div
        style={{
          marginTop: "6px",
          fontWeight: "800",
          color: "#0f172a",
        }}
      >
        {value}
      </div>
    </div>
  );
}

const buttonStyle = {
  background: "#D4AF37",
  color: "#111111",
  border: "none",
  padding: "14px 22px",
  borderRadius: "14px",
  cursor: "pointer",
  fontWeight: "700",
};
